import React, { useMemo } from 'react';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { DownloadIMQsPageStore, DownloadIMQsPageStoreContext } from 'store/pages/download-imqs/pageStore';
import { DownloadIMQsPageContent } from 'components/rfq/initiate-rfq/download-imqs';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import { useParams } from 'react-router-dom';

const DownloadIMQsPage: React.FC = () => {
  const query = useQueryParams();
  const { periodId } = useParams<{ periodId: string }>();
  const groupId = query.get('groupId') || '';
  const cartId = query.get('cartId') || '';

  const pageStore = useMemo(() => new DownloadIMQsPageStore({ periodId, groupId, cartId }), []);

  return (
    <RFQStatusLayout>
      <DownloadIMQsPageStoreContext.Provider value={pageStore}>
        <PageHeader
          title={RFQ_PROPOSAL_CARD_DATA.DOWNLOAD_IMQS.title}
          subtitle={RFQ_PROPOSAL_CARD_DATA.DOWNLOAD_IMQS.text}
        />
        <DownloadIMQsPageContent />
      </DownloadIMQsPageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default DownloadIMQsPage;
